import { render, staticRenderFns } from "./SambatechPlayer.vue?vue&type=template&id=02efe4ce&scoped=true"
import script from "./SambatechPlayer.vue?vue&type=script&lang=js"
export * from "./SambatechPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02efe4ce",
  null
  
)

export default component.exports